import { useFormAiDraftStore } from "@/features/ai-builder/useFormAiDraftStore";
import { TransientFormBuilder } from "@/features/forms/components/form-builder/TransientFormBuilder";
import { formBuilderSearchSchema } from "@/features/forms/components/form-builder/formBuilderSearch";
import { useNav } from "@/utils/nav";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";

function NewAiFormPage() {
    const navigate = useNavigate();
    const routeNavigate = Route.useNavigate();
    const search = Route.useSearch();
    const [draft] = useState(() => useFormAiDraftStore.getState().takeDraft());

    useNav([
        { label: "Builder", route: { to: "/builder" } },
        { label: "Forms", route: { to: "/builder/forms" } },
        { label: draft?.form_name ?? "New AI draft", route: { to: "/builder/forms/new" }, status: "unsaved" },
    ]);

    useEffect(() => {
        if (!draft) void navigate({ to: "/builder/forms", replace: true });
    }, [draft, navigate]);

    return draft ? (
        <TransientFormBuilder
            initialDraft={draft}
            search={search}
            onSelectionChange={(next, options) => void routeNavigate({ search: next, replace: options?.replace })}
        />
    ) : null;
}

export const Route = createFileRoute("/_app/builder/forms/new")({
    component: NewAiFormPage,
    validateSearch: (search) => formBuilderSearchSchema.parse(search),
});
